import { ActionNames } from "../@types/enums";
import { StoredPermissions } from "../@types/permissions";
import { Role } from "../@types/roles";
import { defaultPermissions } from "../_constants/permissions";

// Function to check permissions
export const canPerformAction = (
  action: ActionNames,
  role: Role,
  permissions: StoredPermissions
): boolean => {
  const actionPermissions = permissions[action] ?? defaultPermissions[action];
  return actionPermissions ? actionPermissions[role] : false;
};
